import { render } from "./PointsBookingModal.vue?vue&type=template&id=3044699c&scoped=true"
import script from "./PointsBookingModal.vue?vue&type=script&lang=js"
export * from "./PointsBookingModal.vue?vue&type=script&lang=js"

import "./PointsBookingModal.vue?vue&type=style&index=0&id=3044699c&scoped=true&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3044699c"]])

export default __exports__